import { endpoints } from "../constants/env/middletier";
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import AddClientForm from '../components/AddClientForm';
import AddProjectForm from "../components/AddProjectForm";


export default function ClientsPage() {
    const [allClients, setAllClients] = useState([]);
    const [formVisible, setFormVisible] = useState(false);

    const sortByName = (a, b) => a.name.localeCompare(b.name);

    const fetchClients = async () => {
        try {
            const response = await fetch(Endpoints["client"], {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error("Bad response");
            }

            const data = await response.json();
            const newSource = [...data].sort(sortByName);

            setAllClients(newSource);
            console.log(data);
        } catch (error) {
            console.error("Failed to fetch clients:", error);
        }
    };

    useEffect(() => {
        fetchClients();
    }, []);




    // useEffect(() => {
    //     async function fetchClients() {
    //         const response = await fetch(Endpoints["client"], {
    //             method: "GET"
    //         });
    //         if (!response.ok) throw new Error("Bad response");
    //         const data = await response.json();
    //         const newSource = [...data].sort(sortByName);
    //
    //         setAllClients(newSource);
    //         console.log(data);
    //     }
    //     fetchClients();
    // }, []);

    const header = (
        <div className="flex align-items-center justify-content-between">
            <span className="text-xl text-900 font-bold">
                Clients
            </span>

            <div className="p-inputgroup" style={{ width: 'auto' }}>
                <Button icon="pi pi-plus" rounded text severity="secondary" onClick={() => setFormVisible(true)} />
                <Button icon="pi pi-refresh" rounded text severity="secondary" onClick={() => fetchClients()} />
            </div>
        </div>
    );

    return (
        <>
            <br />
            <br />
            <br />
            <div className="card">
                <DataTable value={allClients} header={header} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="name" header="Name"></Column>
                    <Column field="type" header="Type"></Column>
                    <Column field="phone" header="Phone"></Column>
                    <Column field="description" header="Description"></Column>
                    <Column field="address1" header="Addr 1"></Column>
                    <Column field="address2" header="Addr 2"></Column>
                    <Column field="city" header="City"></Column>
                    <Column field="state" header="State"></Column>
                    <Column field="zip" header="Zip"></Column>
                </DataTable>
            </div>

            <AddClientForm
                formVisible={formVisible}
                setFormVisible={setFormVisible}
            />

        </ >
    );
}